export const EXPORT_PAYROLL_SHEET = (year, month) =>
  `/export_payroll/${year}/${month}/`;
